module.exports = __webpack_public_path__ + "img/wagner_tt.4eaf747a.png";